import api from './api';

const expenseClaimService = {
  getAllClaims: async (params = {}) => {
    try {
      const response = await api.get('/expense-claim', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all expense claim records:', error);
      throw error;
    }
  },

  getClaimById: async (id) => {
    try {
      const response = await api.get(`/expense-claim/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching expense claim record with ID ${id}:`, error);
      throw error;
    }
  },

  getNextClaimNumber: async () => {
    try {
      const response = await api.get('/expense-claim/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next claim number:', error);
      throw error;
    }
  },

  createClaim: async (claimData) => {
    try {
      const response = await api.post('/expense-claim', claimData);
      return response.data;
    } catch (error) {
      console.error('Error creating expense claim record:', error);
      throw error;
    }
  },

  updateClaim: async (id, claimData) => {
    try {
      const response = await api.put(`/expense-claim/${id}`, claimData);
      return response.data;
    } catch (error) {
      console.error(`Error updating expense claim record with ID ${id}:`, error);
      throw error;
    }
  },

  deleteClaim: async (id) => {
    try {
      const response = await api.delete(`/expense-claim/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting expense claim record with ID ${id}:`, error);
      throw error;
    }
  },

  submitClaim: async (id) => {
    try {
      const response = await api.post(`/expense-claim/${id}/submit`);
      return response.data;
    } catch (error) {
      console.error(`Error submitting expense claim with ID ${id}:`, error);
      throw error;
    }
  },

  getClaimStats: async () => {
    try {
      const response = await api.get('/expense-claim/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching expense claim stats:', error);
      throw error;
    }
  },
};

export default expenseClaimService;

